import { useEffect } from "react";
import logoBox from "../../assets/images/logo_box.svg";
import appStoreBorderSvg from "../../assets/images/icons/app_store_border.svg";
import playStoreBorderSvg from "../../assets/images/icons/play_store_border.svg";
import event01Svg from "../../assets/images/event_01.svg";
import event02Svg from "../../assets/images/event_02.svg";
import event03Svg from "../../assets/images/event_03.svg";
import event04Svg from "../../assets/images/event_04.svg";

import "../../assets/css/event_landing.scss";

function EventLanding() {
  useEffect(() => {
    document.body.style.backgroundColor = "#E4EBF5";
  }, []);

  const goStoreUrl = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let storeUrl = "";

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      storeUrl = "https://apps.apple.com/kr/app/키즈다/id6738370393";
    } else {
      storeUrl =
        "https://play.google.com/store/apps/details?id=com.aslo.smartview.donga.kids";
    }

    return storeUrl;
  };

  return (
    <div className="event-container">
      <ul>
        <li>
          <img src={logoBox} alt="" />
        </li>
        <li>
          <span>어린이 동아</span>
          <br />
          <span>Download the app</span>
        </li>
        <li>
          <a href="https://apps.apple.com/kr/app/키즈다/id6738370393">
            <img src={appStoreBorderSvg} alt="" />
          </a>
        </li>
        <li>
          <a href="https://play.google.com/store/apps/details?id=com.aslo.smartview.donga.kids">
            <img src={playStoreBorderSvg} alt="" />
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <img src={event01Svg} alt="" />
          <div className="app-download">
            <button
              onClick={() => {
                window.open(goStoreUrl());
              }}
            >
              앱 다운로드
            </button>
          </div>
        </li>
        <li>
          <img src={event02Svg} alt="" />
        </li>
        <li>
          <img src={event03Svg} alt="" />
        </li>
        <li>
          <img src={event04Svg} alt="" />
        </li>
        <li>
          <div>유의사항</div>
          <ul>
            <li>Event1,2 중복 당첨은 불가합니다.</li>
            <li>
              전화번호를 잘못 입력하거나 문자 수신이 불가능한 경우, 기프티콘은
              재발송되지 않습니다.
            </li>
            <li>
              특별 기사 구독권 환불 시 정가를 기준으로 사용 금액을 차감한 후
              환불이 진행됩니다.
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default EventLanding;
